/**
 * Support page (/support) — storefront targets aligned with App.js routes.
 * Keeps PublicSupportPage from scattering magic paths.
 */
import { LEGAL_PATHS } from "../legal/legalPaths";
import { SITE_MY_LIBRARY_PATH, SITE_PUBLIC_LIBRARY_PATH } from "./siteNavRoutes";

/** NFT Comic & Merch Rights card — merchandiser legal doc + library vault flow. */
export const SUPPORT_NFT_COMIC_MERCH_FLOW = {
  /** Active legal slug: `nft-comic-merch-license` (see legalRegistry / LegalDocumentPage). */
  merchandiserTerms: LEGAL_PATHS.nftComicMerchLicense,
  /** Genesis collector editions and card checkout live on LibraryPage (no separate /mint route). */
  publicLibrary: SITE_PUBLIC_LIBRARY_PATH,
  myLibrary: SITE_MY_LIBRARY_PATH,
};
